<script>
  import InputContainer from "../../../../auto-mps/parts/inputs/InputContainer.svelte";
  import Stack from "../../../layout/Stack.svelte";
  import Checkbox2 from "../../../input/Checkbox2.svelte";

  /**
   * @type {string}
   */
  export let label = "曜日"

  export let selectedWeekdays = {
    "sunday": false,
    "monday": false,
    "tuesday": false,
    "wednesday": false,
    "thursday": false,
    "friday": false,
    "saturday": false,
  }

  const translations = {
    monday: "月曜日",
    tuesday: "火曜日",
    wednesday: "水曜日",
    thursday: "木曜日",
    friday: "金曜日",
    saturday: "土曜日",
    sunday: "日曜日",
  }

  $: numChecked = Object.values(selectedWeekdays).filter(val => val).length
</script>

<InputContainer>
  <span slot="label">{label}</span>
  <Stack direction="horizontal">
    {#each Object.keys(translations) as dayOfWeek}
      <Checkbox2
        bind:checked={selectedWeekdays[dayOfWeek]}
        disabled={selectedWeekdays[dayOfWeek] && numChecked === 1}
        label={translations[dayOfWeek]}
      />
    {/each}
  </Stack>
</InputContainer>
